export default __webpack_public_path__ + "static/3-7505012083feb2b2f58f1bd24b517bc6.jpeg";